var filter = require('../array/virtual/filter');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.filter;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.filter) ? filter : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/filter.js
// module id = 987
// module chunks = 0